class ProductMedia extends HTMLElement {
	
    
    constructor() {

        super();

        this.img_cards = this.querySelectorAll('.image-card');
        this.large_anchors = this.querySelectorAll('.large-media-anchor');
        this.large_img_container = this.querySelector('.large-images');

        this.dots = this.querySelectorAll('.dot-indicator');
        this.io_options = { 
            // threshold: 0.5
            // threshold: 0.1 
            // rootMargin: '0px -150px 0px 0px'
            rootMargin: '0% -65% 0% 0%'
        }

        this.set_dotIndicatorObserver(); 
        this.set_cursorListeners(); 
        this.set_largeImgListeners();      
        
    }


    set_cursorListeners() {

        this.img_cards.forEach(card => {

            let controls_layer = card.querySelector(".image-card-controls");
            let cursor = controls_layer.querySelector(".custom-cursor");
           
            controls_layer.addEventListener('mouseenter', () => {
                card.classList.add('mouse-entered', 'hovering');
            });

            controls_layer.addEventListener('mouseleave', () => {
                card.classList.remove('mouse-entered', 'hovering');
            });

            controls_layer.addEventListener('mousemove', (e) => {
                let x = e.offsetX;
                let y = e.offsetY;
                cursor.style.setProperty("--x", x + "px");
                cursor.style.setProperty("--y", y + "px");             
            });

        })
    }


    set_largeImgListeners() {

        this.large_anchors.forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                this.on_AnchorClick(e);

                // e.preventDefault();
                // this.large_img_container.open = true;
                // let temp = anchor.href.split('#')[1];
                // let element = document.getElementById(`${temp}`);
                // if (element) {
                //     element.scrollIntoView({ behavior: 'smooth' });
                // }

            });
        })

    }


    on_AnchorClick(e) {
		e.preventDefault();
		this.large_img_container.hasAttribute('open') ? this.close() : this.open(e);
  	}


    open(e) {

		this.large_img_container.setAttribute('open', true);
		document.body.classList.add('overflow-hidden');

		// console.log(this.detailsContainer.querySelector('[tabindex="-1"]'))
		// console.log(this.detailsContainer.querySelector('input:not([type="hidden"])'))

		// trapFocus(this.large_img_container.querySelector('ul'), this.large_img_container.querySelector('summary'));

	}


	close(focusToggle = true) {
		// removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.large_img_container.removeAttribute('open');
		document.body.classList.remove('overflow-hidden');
		// document.body.removeEventListener('click', this.onBodyClickEvent);
	}


    set_dotIndicatorObserver() {

        const setVisible = (entries, observer) => {
            entries.forEach(entry => { 
                entry.isIntersecting ? addClass(entry.target) : removeClass(entry.target) 
            })
        }

        const addClass = (el) => {
            if (!el.classList.contains('is-visible')) {
                el.classList.add('is-visible');
                const elID = el.dataset.id;   
                this.dots.forEach((dot) => {
                    if(dot.dataset.id === elID) { dot.classList.add('is-visible') }
                })
            }
        }

        const removeClass = (el) => {
            if (el.classList.contains('is-visible')) {
                el.classList.remove('is-visible');
                const elID = el.dataset.id;        
                this.dots.forEach((dot) => {
                    if(dot.dataset.id === elID) { dot.classList.remove('is-visible') }
                })
            }
        }

        const observer = new IntersectionObserver(setVisible, this.io_options)
        this.img_cards.forEach(target => { observer.observe(target) })

    }



}
customElements.define('product-media', ProductMedia);